<c-modal #staticBackdropModal backdrop="static" size="lg" visible='true' id="staticBackdropModal">
    <c-modal-header>
        <h4 class="modal-title">{{ "Owner Detail" }}</h4>
        <button [cModalToggle]="staticBackdropModal.id" cButtonClose (click)="closeModal()" title="Close"></button>
    </c-modal-header>
    <c-modal-body>
        <c-row>
            <form cForm class="animate" (ngSubmit)="saveOwner()" [formGroup]="ownerDetailForm">
                <c-row>
                    <c-col [md]="3">
                        <label cLabel for="firstName">{{
                            "First Name"
                            }}</label>
                    </c-col>
                    <c-col [md]="8">
                      <input cFormControl formControlName="firstName" name="firstName" type="text" class="form-control" id="firstName" />
                      <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!ownerDetailForm.controls['firstName'].valid && !ownerDetailForm.controls['firstName'].untouched">
                          {{ "Owner first name is required" }}
                      </div>
                    </c-col>
                </c-row>
                <c-row>
                  <c-col [md]="3">
                    <label cLabel for="lastName">
                      {{"Last Name"}}
                    </label>
                  </c-col>
                  <c-col [md]="8">
                    <input cFormControl formControlName="lastName" name="lastName" type="text" class="form-control" id="lastName" />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!ownerDetailForm.controls['lastName'].valid && !ownerDetailForm.controls['lastName'].untouched">
                        {{ "Owner last name is required" }}
                    </div>
                  </c-col>
              </c-row>
                <c-row>
                  <c-col [md]='3'>
                    <label cLabel for="phone">
                      {{"Phone" }}
                    </label>
                  </c-col>
                  <c-col [md]='8'>
                    <input cFormControl formControlName="phone" name="phone" type="text" class="form-control" id="phone" />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="ownerDetailForm.controls['phone'].hasError('required') && !ownerDetailForm.controls['phone'].untouched">
                        {{ "Phone is required." }}
                    </div>
                  </c-col>
                </c-row>
                <c-row>
                  <c-col [md]='3'>
                    <label cLabel for="email">
                      {{"Email" }}
                    </label>
                  </c-col>
                  <c-col [md]='8'>
                    <input cFormControl formControlName="email" name="email" type="text" class="form-control" id="email" />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="ownerDetailForm.controls['email'].hasError('required') && !ownerDetailForm.controls['email'].untouched">
                        {{ "Email is required." }}
                    </div>
                  </c-col>
                </c-row>
                <c-row>
                  <c-col [md]='3'>
                    <label cLabel for="address">
                      {{"Address" }}
                    </label>
                  </c-col>
                  <c-col [md]='8'>
                    <input cFormControl formControlName="address" name="address" type="text" class="form-control" id="address" />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="ownerDetailForm.controls['address'].hasError('required') && !ownerDetailForm.controls['address'].untouched">
                        {{ "Address is required." }}
                    </div>
                  </c-col>
                </c-row>

                <!-- Emergency Contact -->
                <c-row>
                  <c-col [md]='3'>
                    <label cLabel for="emergencyContact">
                      {{"Emergency Contact" }}
                    </label>
                  </c-col>
                  <c-col [md]='8'>
                    <input cFormControl formControlName="emergencyContact" name="emergencyContact" type="text" class="form-control" id="emergencyContact" />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="ownerDetailForm.controls['emergencyContact'].hasError('required') && !ownerDetailForm.controls['emergencyContact'].untouched">
                        {{ "Emergency contact is required." }}
                    </div>
                  </c-col>
                </c-row>

                <!-- Nationality -->
                <c-row>
                  <c-col [md]='3'>
                      <label cLabel for="nationality">
                          {{"Nationality" }}
                      </label>
                  </c-col>
                  <c-col [md]='8'>
                    <input
                      formControlName="nationality" name="nationality" type="text" id="nationality"
                      cFormControl
                      placeholder="Select Nationality"
                      [typeaheadOptionsLimit]="10"
                      [typeaheadLatinize]="true"
                      [typeahead]="nationalityList"
                      typeaheadOptionField="name"
                      [typeaheadMinLength]="0"
                      (typeaheadOnSelect)="onSelectNationality($event)"
                    />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="ownerDetailForm.controls['nationality'].hasError('required') && !ownerDetailForm.controls['nationality'].untouched">
                        {{ "Nationality is required." }}
                    </div>
                  </c-col>
                </c-row>
                <c-row>
                  <c-col [md]='3'>
                    <label cLabel for="typeId">
                      {{"Type" }}
                    </label>
                  </c-col>
                  <c-col [md]='8'>
                    <input cFormControl formControlName="typeId" name="typeId" type="text" class="form-control" id="typeId"
                        placeholder="Select type"
                        [typeaheadOptionsLimit]="10"
                        [typeaheadLatinize]="true"
                        [typeahead]="ownerTypes"
                        typeaheadOptionField="name"
                        [typeaheadMinLength]="0"
                        (typeaheadOnSelect)="onSelectOwnerType($event)"
                    />
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="ownerDetailForm.controls['typeId'].hasError('required') && !ownerDetailForm.controls['typeId'].untouched">
                        {{ "Type is required." }}
                    </div>
                  </c-col>
                </c-row>

                <!-- Vet Details -->
                <c-row>
                  <c-col [md]='3'>
                    <label cLabel for="vetDetails">
                      {{"Vet Details" }}
                    </label>
                  </c-col>
                  <c-col [md]='8'>
                    <textarea cFormControl formControlName="vetDetails" name="vetDetails" class="form-control" id="vetDetails" title="Vet Details" rows="3"></textarea>
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="ownerDetailForm.controls['vetDetails'].hasError('required') && !ownerDetailForm.controls['vetDetails'].untouched">
                        {{ "Vet details is required." }}
                    </div>
                  </c-col>
                </c-row>

                <!-- How Did You Hear About Good Dog -->
                <c-row>
                  <c-col [md]='3'>
                      <label cLabel for="howDidYouHearAboutGoodDog">
                          {{"How Did You Hear About Good Dog?" }}
                      </label>
                  </c-col>
                  <c-col [md]='8'>
                    <c-form-check [inline]="true">
                      <input cFormCheckInput formControlName="howDidYouHearAboutGoodDog" id="FacebookHowDidYouHearAboutGoodDog" type="radio" value="Facebook" title="Facebook" />
                      <label cFormCheckLabel for="FacebookHowDidYouHearAboutGoodDog">Facebook</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="howDidYouHearAboutGoodDog" id="WebsiteHowDidYouHearAboutGoodDog" type="radio" value="Website" title="Website" />
                      <label cFormCheckLabel for="WebsiteHowDidYouHearAboutGoodDog">Website</label>
                    </c-form-check>
                    <c-form-check [inline]="true">
                      <input cFormCheckInput formControlName="howDidYouHearAboutGoodDog" id="FriendsHowDidYouHearAboutGoodDog" type="radio" value="Friends" title="Friends" />
                      <label cFormCheckLabel for="FriendsHowDidYouHearAboutGoodDog">Friends</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="howDidYouHearAboutGoodDog" id="RelativesHowDidYouHearAboutGoodDog" type="radio" value="Relatives" title="Relatives" />
                      <label cFormCheckLabel for="RelativesHowDidYouHearAboutGoodDog">Relatives</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="howDidYouHearAboutGoodDog" id="othersHowDidYouHearAboutGoodDog" type="radio" value="Others" title="Others" />
                      <label cFormCheckLabel for="othersHowDidYouHearAboutGoodDog">Others</label>
                    </c-form-check>
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="ownerDetailForm.controls['howDidYouHearAboutGoodDog'].hasError('required') && !ownerDetailForm.controls['howDidYouHearAboutGoodDog'].untouched">
                        {{ "howDidYouHearAboutGoodDog is required." }}
                    </div>
                  </c-col>
                </c-row>

                <!-- How Did You Hear About Good Dog - Other -->
                <c-row *ngIf="selectedReferral=='Others'">
                  <c-col [md]='3'>
                    <label cLabel for="howDidYouHearAboutGoodDogOther">
                      {{"Others" }}
                    </label>
                  </c-col>
                  <c-col [md]='8'>
                    <input cFormControl formControlName="howDidYouHearAboutGoodDogOther" name="howDidYouHearAboutGoodDogOther" type="text" class="form-control" id="howDidYouHearAboutGoodDogOther" title="How Did You Hear About Good Dog - Other"/>
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="ownerDetailForm.controls['howDidYouHearAboutGoodDogOther'].hasError('required') && !ownerDetailForm.controls['howDidYouHearAboutGoodDogOther'].untouched">
                        {{ "How Did You Hear About Good Dog Other is required." }}
                    </div>
                  </c-col>
                </c-row>
                <c-row *ngIf="hasEditPermission || hasAddPermission">
                    <c-col [md]='3'></c-col>
                    <c-col [md]='8'>
                      <button type="submit" [disabled]="!ownerDetailForm.valid" class="btn btn-primary primary w-100">
                          <i class="fa fa-circle-o-notch fa-spin" [hidden]="!isSavingOwner"></i>
                          <c-spinner [hidden]="!isSavingOwner"></c-spinner>{{ "Submit" }}
                      </button>
                    </c-col>
                </c-row>
            </form>
        </c-row>
    </c-modal-body>
</c-modal>
